/* tslint:disable */
/* eslint-disable */
/**
 * Adyen Card Enrollment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CreateActionResultResponseDataAdyenData,
    CreateActionResultResponseDataAdyenDataFromJSON,
    CreateActionResultResponseDataAdyenDataFromJSONTyped,
    CreateActionResultResponseDataAdyenDataToJSON,
} from './CreateActionResultResponseDataAdyenData';

/**
 * 
 * @export
 * @interface CreateActionResultResponseData
 */
export interface CreateActionResultResponseData {
    /**
     * 
     * @type {CreateActionResultResponseDataAdyenData}
     * @memberof CreateActionResultResponseData
     */
    adyenData: CreateActionResultResponseDataAdyenData;
    /**
     * URL that the client should redirect to on completion. Will be intercepted by the app.
     * @type {string}
     * @memberof CreateActionResultResponseData
     */
    interceptUrl?: string;
    /**
     * message to display to the user before redirecting to the interceptUrl.
     * @type {string}
     * @memberof CreateActionResultResponseData
     */
    message?: string;
}

export function CreateActionResultResponseDataFromJSON(json: any): CreateActionResultResponseData {
    return CreateActionResultResponseDataFromJSONTyped(json, false);
}

export function CreateActionResultResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateActionResultResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'adyenData': CreateActionResultResponseDataAdyenDataFromJSON(json['adyenData']),
        'interceptUrl': !exists(json, 'interceptUrl') ? undefined : json['interceptUrl'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function CreateActionResultResponseDataToJSON(value?: CreateActionResultResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'adyenData': CreateActionResultResponseDataAdyenDataToJSON(value.adyenData),
        'interceptUrl': value.interceptUrl,
        'message': value.message,
    };
}

